import React from 'react';
import { Section, SectionSubTitle } from 'common/components';
import { ProductCollapse } from '../product-collapse';
import { productDescription, productDescriptionText } from './product-description-styles';

type ProductDescriptionProps = {
  description: string;
  onShowMoreClick?: (buttonName: string, elementName: string) => void;
};

export const ProductDescription: React.FC<ProductDescriptionProps> = ({ description, onShowMoreClick }) => (
  <Section className={productDescription}>
    <SectionSubTitle adaptiveMargin margin="s">
      Описание
    </SectionSubTitle>
    <ProductCollapse elementName="Описание" onShowMoreClick={onShowMoreClick}>
      <div
        className={productDescriptionText}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </ProductCollapse>
  </Section>
);
